import React from "react";

import { Menu, Item, Separator, Submenu, useContextMenu } from "react-contexify";

import "react-contexify/dist/ReactContexify.css";

import { useEffect, useRef, useState } from "react";
import DialogBuchen from "../../dialogs/DialogBuchen";
import { Modal } from "../Modal";
import "./OneRect.scss";

import { ServerInterface } from "../../ServerInterface";
import { Functions } from "../../Functions";

import { getDOY, _common } from "../../common";
import moment from "moment";
const common = _common;

function isBookingWithMe(booking: any) {
  if (common.clubhausMode) {
    return false;
  }

  if (common.anzeigeTafelMode) {
    return false;
  }
  for (var p in booking.partners) {
    var partner = booking.partners[p];
    if (partner.indexOf(common.userMemberId) >= 0) {
      return true;
    }
  }

  return false;
}

export default function OneRect(props: {
  disableInput: boolean;
  date: Date;
  numHours: number;
  court: number;
  numCourts: number;
  privateBooking: boolean;
  booking: any | undefined;
  onReDraw: () => void;
}) {
  const { disableInput, date, numHours, numCourts, onReDraw } = props;

  var booking: any | undefined = undefined;
  if (props.booking) {
    booking = { ...props.booking };
  }

  var { privateBooking, court } = props;
  const [isSelected, setIsSelected] = useState(false);
  const [showDialogBuchen, setShowDialogBuchen] = useState(false);

  const [isMoving, setIsMoving] = useState(false);

  const key = `r-${court}-${date.getHours()}${booking == undefined ? "-b" : ""}`;

  const MENU_ID = "m" + key;
  const { show } = useContextMenu({
    id: MENU_ID,
  });

  const elmRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (elmRef.current) {
      const textOuter = elmRef.current.querySelector("#textOuter");
      if (textOuter) {
        const textInner = elmRef.current.querySelector("#textInner");
        if (textInner) {
          const f = Math.min(1, (textOuter.clientWidth - 10) / textInner.clientWidth);
          (textInner as any).style.transform = `scale(${f})`;
        }
      }

      setIsMoving(common.currentBookingIsMoving && booking && common.myNextBookingInfo?.uid == booking.uid);
    }
  });

  if (court == undefined || court < 1 || court > 7 || isNaN(court)) {
    console.error("invalid court", booking);
    court = 1;
  }

  //
  // calculate Position from courtNumber and hour
  //
  const posY = (date.getHours() - common.firstHourOfDay + date.getMinutes() / 60) * common.heightHour;
  const sizeY = numHours * common.heightHour;

  var posX1 = (court - 1) * common.widthCourt;
  posX1 += common.courtSpacing[court - 1];

  const addSizeX = common.courtSpacing[court - 1 + numCourts - 1] - common.courtSpacing[court - 1];

  var sizeX = numCourts * common.widthCourt + addSizeX;

  ////////////////////////////////////////////////////////////////////////////

  async function onclick(ev: any) {
    if (booking != undefined) {
      show({
        event: ev,
        position: { x: posX1, y: posY },
      });
    } else {
      if (common.currentBookingIsMoving) {
        await ServerInterface.deleteBooking(common.myNextBookingInfo);

        const d = new Date(date);

        const bookingInfo = {
          ...common.myNextBookingInfo,
        };

        bookingInfo.dateCreated = new Date();
        bookingInfo.court = court;

        bookingInfo.oldDate = bookingInfo.date;
        bookingInfo.date = d;

        // for backward compatibility
        bookingInfo.dayIndex = getDOY(d);
        bookingInfo.minutes = d.getMinutes();
        bookingInfo.hour = d.getHours();

        bookingInfo.user = common.user;
        bookingInfo.dateModified = new Date();

        await ServerInterface.book(bookingInfo);
        common.currentBookingIsMoving = false;
        common.myNextBookingInfo = undefined;

        onReDraw();
      } else {
        setShowDialogBuchen(true);
      }
      // alert(`click court=${court} time=${startTime}`);
    }
  }

  function prepareText(): { text: string; color: string; backgroundColor: string } {
    const result = { text: "", color: "black", backgroundColor: "transparent" };

    var xIsBookingWithMe = false;
    if (privateBooking) {
      xIsBookingWithMe = isBookingWithMe(booking);
    }

    if (isMoving) {
      result.text = "VERSCHIEBEN\n";
      result.color = "white";
      result.backgroundColor = "#00a";
    } else if (isSelected) {
      result.backgroundColor = "#00a";
      result.color = "white";
    } else if (privateBooking) {
      if (xIsBookingWithMe) {
        result.color = "white";
        result.backgroundColor = "#00a";
      } else {
        if (common.anzeigeTafelMode) {
          // result.color = "white";
          const now = new Date();
          const mnow = moment(now);

          const mnow2 = moment(now).subtract(15, "minutes");
          const mnow3 = moment(now).add(15, "minutes");

          const d1 = new Date(booking.date);
          const bookingStarttime = moment(d1);

          if (bookingStarttime.isBefore(mnow2)) {
            result.backgroundColor = "#67c267";
          } else if (bookingStarttime.isBefore(mnow3)) {
            result.backgroundColor = "yellow";
          } else {
            result.backgroundColor = "#8f8";
          }
        } else {
          result.backgroundColor = "yellow";
        }
      }
    } else {
      result.backgroundColor = "orange";
    }

    var showNames = false;

    if (privateBooking) {
      showNames = xIsBookingWithMe || common.kreuzbergMode;

      if (booking.text) {
        result.text = booking.text;
        const ss = booking.text.split("gegen");
        if (ss.length == 2) {
          result.text = ss.join("\n\ngegen\n\n");
        }
        result.backgroundColor = "#e2dd98";
      } else {
        for (var p in booking.partners) {
          var partner = booking.partners[p];
          var partnerName = partner.split(";")[1];
          if (partnerName) {
            var ss = partnerName.split(" ");

            const namenMehrzeilig = false;
            if (namenMehrzeilig) {
              partnerName = ss[0] + "\n";
              for (let i = 1; i < ss.length; i++) {
                partnerName += ss[i];
                if (i < ss.length - 1) {
                  partnerName += " ";
                }
              }
            }

            const vornamenKürzen = true;
            if (vornamenKürzen) {
              //
              // für "NichtGäste" den Vornamen kürzen
              //
              if (partner.split(";")[0] != "9999") {
                ss[0] = ss[0].substr(0, 1) + ".";
                partnerName = ss.join(" ");
              }
            }

            //
            // falls die namen ohnehin angezeigt werden,
            // oder der partner öffentlich bucht
            //
            var isPublic = partner.indexOf(";#pb") > 0 || common.clubhausMode || common.anzeigeTafelMode;
            if (showNames || isPublic) {
              result.text += partnerName + "\n";
            } else {
              result.text += "-" + "\n";
            }
          } else {
            console.error("invalid partner: <" + partner + ">");
          }
        }
        result.text = result.text.substring(0, result.text.length - 1);
      }
    }

    ///////////////////////////////////////////////////////////
    // Spezialbuchungen ....

    if (booking && booking.partners && booking.partners.length > 0 && parseInt(booking.partners[0].split(";")[0]) < 20) {
      privateBooking = false;
      result.text = booking.partners[0].split(";")[1];
      if (booking.text) {
        result.text += "\n" + booking.text;
      }
      result.backgroundColor = "orange";
    }
    ///////////////////////////////////////////////////////////

    return result;
  }

  //
  // return RenderResult
  //

  const textInfo = prepareText();
  // if (booking) {
  //   console.log(`render OneRect ${textInfo.text} date=${date} ${textInfo.text}`, booking);
  // }

  const elmLines: any = [];

  textInfo.text.split("\n").map((value, index) => {
    elmLines.push(
      <div key={index}>
        {value}
        <br />
      </div>
    );
  });

  return (
    <div
      ref={elmRef}
      key={key}
      className="oneRect"
      style={{
        position: "absolute",
        left: posX1,
        top: posY,
        width: sizeX,
        height: sizeY,
        border: "1px solid grey",
        background: disableInput ? "darkGreen" : "green",
        boxSizing: "border-box",
        cursor: disableInput ? "not-allowed" : "pointer",
      }}
      onClick={(ev) => {
        if (!disableInput) {
          onclick(ev);
        }
      }}
    >
      {!booking && (
        <div
          className="time"
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "none",
          }}
        >
          {date.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit" })}
        </div>
      )}

      {booking && (
        <div
          key="textOuter"
          id="textOuter"
          style={{
            backgroundColor: textInfo.backgroundColor,
            color: textInfo.color,
            width: "100%",
            height: "100%",
            display: "flex",
            lineHeight: "1.2em",
            justifyContent: "center",
            alignItems: "center",
            pointerEvents: "none",
          }}
        >
          <div key="textInner" id="textInner" style={{ whiteSpace: "nowrap" }}>
            {elmLines}
          </div>
        </div>
      )}
      {booking && (
        <Menu key="m" id={MENU_ID}>
          <Item
            key={"l"}
            onClick={async () => {
              await Functions.deleteBooking(booking);
              onReDraw();
            }}
          >
            Löschen
          </Item>

          {booking.uidSerie && (
            <Item
              key={"ls"}
              onClick={async () => {
                await Functions.deleteBookingSerie(booking);
                onReDraw();
              }}
            >
              Löschen Serie
            </Item>
          )}

          <Item
            key={"v"}
            onClick={() => {
              common.currentBookingIsMoving = true;
              common.myNextBookingInfo = booking;
              setIsMoving(true);
            }}
          >
            Verschieben
          </Item>
        </Menu>
      )}
      <Modal
        key="buchen"
        isOpen={showDialogBuchen}
        coverApp={true}
        close={() => {
          setShowDialogBuchen(false);
        }}
      >
        <DialogBuchen
          date={date}
          court={court}
          onReDraw={onReDraw}
          close={() => {
            setTimeout(() => {
              setShowDialogBuchen(false);
            }, 10);
          }}
        />
      </Modal>
    </div>
  );
}
